import { render } from "./navelementButton.vue?vue&type=template&id=5f407ef2&scoped=true"
import script from "./navelementButton.vue?vue&type=script&lang=js"
export * from "./navelementButton.vue?vue&type=script&lang=js"

import "./navelementButton.vue?vue&type=style&index=0&id=5f407ef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f407ef2"]])

export default __exports__